import { render, staticRenderFns } from "./ShipmentStatus.vue?vue&type=template&id=4a463a3a&"
import script from "./ShipmentStatus.vue?vue&type=script&lang=js&"
export * from "./ShipmentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports